<template>
    <div class="chat-parent-container">
        <div class="chat-icon" @mousedown="onMessageSend">
            <svg :style="{ fill: iconColor }" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M33.6 15.0001C33.4 14.7001 33.1 14.4001 32.7 14.3001C32.4 14.2001 32.2 14.2001 31.9 14.3001L15.3 19.3001C15 19.4001 14.6 19.6001 14.5 20.0001C14.3 20.3001 14.2 20.7001 14.3 21.1001C14.4 21.5001 14.7 21.8001 15.1 22.0001L22.4 25.6001L26 32.9001C26.2 33.4001 26.8 33.7001 27.3 33.7001C27.5 33.7001 27.7 33.7001 27.9 33.6001C28.3 33.4001 28.6 33.1001 28.7 32.7001L33.7 16.1001C33.8 15.7001 33.8 15.3001 33.6 15.0001ZM27.3 32.1001L23.9 25.2001L28 21.0001C28.3 20.7001 28.3 20.2001 28 19.9001C27.7 19.6001 27.2 19.6001 26.9 19.9001L22.8 24.0001L15.8 20.6001L32.2 15.6001L27.3 32.1001Z"
                    />
            </svg>
        </div>

        <textarea v-model="inputValue" id="chat_input" ref="textarea" placeholder="我想提問..." rows="1" class="chat-input"
            :style="{ borderColor: borderColor }"
            :readonly="readonly" @keydown.enter.prevent @keydown.enter.exact="onMessageSend"
            @keydown.enter.shift.exact="onNewLine" @focusin="emit('onFocused')"
            @focusout="emit('onOutOfFocus')"></textarea>
    </div>
</template>

<script setup lang="ts">
import { defineModel, defineProps, defineEmits, nextTick, watch } from 'vue';
import { scrollToBottom } from '@/utils/scrollUtils';

const inputValue = defineModel<string>({ required: true });

const props = defineProps<{
    isChatEnabled: boolean;
    isFocused: boolean;
    readonly: boolean;
    borderColor?: string;
    iconColor?: string;
    placeholderColor?: string;
}>();

const emit = defineEmits<{
    onMessageSend: [],
    onFocused: [],
    onOutOfFocus: []
}>();

watch(inputValue, () => {
    resizeTextarea();
});

watch(() => props.isFocused, (isFocused) => {
    if (isFocused) {
        focus();
    } else {
        blur();
    }
});

function resizeTextarea() {
    nextTick(() => {
        const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
        chatInput.style.height = 'auto';
        chatInput.style.height = chatInput.scrollHeight + 'px';
    });
}

function onNewLine() {
    const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
    inputValue.value += '\n';
    scrollToBottom(chatInput);
}

function onMessageSend() {
    emit('onMessageSend');
}

function focus() {
    const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
    chatInput.focus();
}

function blur() {
    const chatInput = document.getElementById('chat_input') as HTMLTextAreaElement;
    chatInput.blur();
}

</script>

<style scoped>
.chat-parent-container {
    position: relative;
}

.chat-icon {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.chat-input {
    display: block;
    width: 100%;
    min-height: 48px;
    max-height: 112px;
    overflow-y: hidden;
    resize: none;
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    padding-left: 16px;
    padding-right: 50px;
    padding-top: 12.5px;
    padding-bottom: 12.5px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 1px;
    border-radius: 4px;
}

.chat-input::placeholder {
    font-family: 'Noto Sans TC', sans-serif;
    font-size: 14px;
    margin: auto;
    color: v-bind(placeholderColor);
}

.chat-input:focus {
    outline: none;
}
</style>